<template>
  <div style="padding:20px;">
    <h1>Latest Sales</h1>
    <p><strong>Note:</strong> Totals are without tax (except for fuel which is tax included)</p>
    <p>Refreshes every 10 seconds.</p>
    <h4>RCGB</h4>

    <div style="width:400px">
      <BasicTableComponent :list="rcgbList" :formatters="listFormatters" :titles="listTitles"/>
    </div>
    
    <h4>RMGB</h4>
    <div style="width:400px">    
      <BasicTableComponent :list="rmgbList" :formatters="listFormatters" :titles="listTitles"/>
    </div>
    
    <h4>WGB</h4>
    <div style="width:400px">    
      <BasicTableComponent :list="wgbList" :formatters="listFormatters" :titles="listTitles"/>
    </div>


  </div>

</template>

<script>
export default {
  name: 'LatestSales',
  data () { return { 
      rcgbList: [],
      rmgbList: [],
      wgbList: [],
      listFormatters: {'DateTime' : ['d', 'ddd h:mm a']},
      listTitles: {
        'DateTime' : 'Timestamp', 
      }
    } 
  },
  async created () {
    this.updateData();    
  },
  mounted() {
    this.interval = setInterval(this.updateData, 10000);
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    updateData: function(){
      if (!document.hasFocus() && this.rcgbList.length > 0){
        return;
      }
      i_axios.post('/LiveData/latestSales', {location:'RCGB'}).then((r)=>{
        this.rcgbList = r.data
      })
      i_axios.post('/LiveData/latestSales', {location:'RMGB'}).then((r)=>{
        this.rmgbList = r.data
      })
      i_axios.post('/LiveData/latestSales', {location:'WGB'}).then((r)=>{
        this.wgbList = r.data
      })
    
    }
  },
}
</script>

<style>

</style>
